<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('分类名称')" prop="categoryName" >
        <a-input v-model="form.categoryName" :maxLength="50" :placeholder="$t('请输入')+$t('分类名称')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['categoryName']"
            input-type="input"
            table-name="goods_goods_category"
            table-field="categoryName"
            :field-value="form.categoryName"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item v-if="showCategoryCode" label="品类编码" prop="categoryCode" >
        <a-input :value="form.categoryCode" :maxLength="categoryCodeLength"
                 :placeholder="'请输入' + categoryCodeLength + '位大写字母，如 ' + categoryCodePlaceholder"
                 @input="e => form.categoryCode = e.target.value.toUpperCase()" />
      </a-form-model-item>
      <a-form-model-item :label="$t('分类图片')" prop="categoryPic">
        <oss-upload-single :height="100" :width="100"  v-model="form.categoryPic" prefix="goods" type="img"/>
        <span>推荐尺寸 60 x 60</span>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('上级分类')" prop="pid" >
        <a-tree-select v-model="form.pid" style="width: 100%" :disabled="userInfo.deptType===2"
                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="this.$t('请选择')+this.$t('上级分类')"
                       :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                       tree-default-expand-all>
        </a-tree-select>
      </a-form-model-item>-->
      <a-form-model-item v-if="isTopLevel && isMerchant" label="商城归属" prop="bizScope" >
        <a-radio-group v-model="form.bizScope" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.BizScopeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('是否显示')" prop="isVisible" >
        <a-radio-group v-model="form.isVisible" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('是否首页展示')" prop="isHomeVisible" >
        <a-radio-group v-model="form.isHomeVisible" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="关键词" prop="keyWord" >
        <a-input v-model="form.keyWord" type="textarea" :maxLength="500" :placeholder="$t('请输入')+'关键词'" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" type="textarea" :maxLength="500" :placeholder="$t('请输入')+'备注'" />
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('是否参与筛选')" prop="isFilter" >
        <a-radio-group v-model="form.isFilter" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getCategory,
  addCategory,
  updateCategory,
  merchantCategoryTree, merchantIdCategoryTree
} from '@/api/goods/category'
import {mapGetters} from 'vuex'
import {generateFilePath,uploadOss, uploadObject} from "@/api/tool/oss";
import CustomDictTag from "@/components/DictCustomTag";
import {translation} from "@/api/tool/common";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    LocaleFieldButton,
    CustomDictTag,
  },
  data () {
    return {
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('分类名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'categoryName' },
          key: 'name'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      cateOptions: [],
      loading: null,
      imgCaseList: [],
      // 表单参数
      form: {
        id: null,
        categoryName: null,
        categoryCode: null,
        localeList: [],
        categoryPic: null,
        goodsType:1,
        bizScope: undefined,
        pid: null,
        level: null,
        keyWord: null,
        isVisible: null,
        isFilter: null,
        isHomeVisible: null,
        sort: null,
        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      // 修改前的品类编码，用于判断编码是否被改动（未改动时不校验位数，避免历史3位配件编码被拦截）
      originalCategoryCode: null,
      open: false,
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict','userInfo']),
    isTopLevel () {
      return this.form.pid === '0' || this.form.pid === 0 || this.form.pid === null || this.form.pid === undefined
    },
    isMerchant () {
      return this.userInfo.deptType === 2
    },
    // 品类编码只由平台维护，平台任意层级（含一级）都可维护；商家分类不使用
    showCategoryCode () {
      return !this.isMerchant
    },
    // 一级分类（乐器分类/二手分类/配件分类）的品类编码选填，第2~4级必填
    isCategoryCodeRequired () {
      return !this.isMerchant && !this.isTopLevel
    },
    // 品类编码位数按商城归属区分：配件 4 位，乐器/二手 3 位
    categoryCodeLength () {
      return Number(this.form.bizScope) === 3 ? 4 : 3
    },
    categoryCodePlaceholder () {
      return Number(this.form.bizScope) === 3 ? 'KPOO' : 'POO'
    },
    rules () {
      const rules = {
        categoryName: [
          { required: true, message: this.$t('分类名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        pid: [
          { required: true, message:  this.$t('上级分类')+this.$t('不能为空'), trigger: 'change' }
        ],
        goodsType: [
          { required: true, message:  '商品分类'+this.$t('不能为空'), trigger: 'change' }
        ],
        categoryPic: [
          { required: false, message:  this.$t('分类图片')+this.$t('不能为空'), trigger: 'blur' }
        ],
        isVisible: [
          { required: true, message:  this.$t('是否显示')+this.$t('不能为空'), trigger: 'blur' }
        ],
        isHomeVisible: [
          { required: true, message:  this.$t('是否首页显示')+this.$t('不能为空'), trigger: 'blur' }
        ],
      }
      // 商家一级分类仍然自己选择商城归属，平台分类由父级继承
      if (this.isTopLevel && this.isMerchant) {
        rules.bizScope = [
          { required: true, message:  '商城归属'+this.$t('不能为空'), trigger: 'change' }
        ]
      }
      if (this.showCategoryCode) {
        const categoryCodeRules = []
        //编辑时编码未改动不做位数校验，避免历史3位配件品类编码改个名称就被拦截
        const codeChanged = this.formType === 1 || this.form.categoryCode !== this.originalCategoryCode
        if (codeChanged) {
          categoryCodeRules.push({
            pattern: this.categoryCodeLength === 4 ? /^[A-Z]{4}$/ : /^[A-Z]{3}$/,
            message: '品类编码必须为' + this.categoryCodeLength + '位大写字母',
            trigger: 'blur'
          })
        }
        if (this.isCategoryCodeRequired) {
          categoryCodeRules.unshift({ required: true, message: '品类编码'+this.$t('不能为空'), trigger: 'blur' })
        }
        rules.categoryCode = categoryCodeRules
      }
      return rules
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.originalCategoryCode = null
      this.cateOptions = []
      this.form = {
        id: null,
        categoryName: null,
        categoryCode: null,
        categoryPic: null,
        pid: null,
        goodsType:1,
        bizScope: undefined,
        level: null,
        isFilter: null,
        isVisible: null,
        keyWord: null,
        isHomeVisible: null,
        sort: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /*getCateList() {
      listCategory({level: 1}).then(response => {
        const cate = { id: "0", categoryName: this.$t('根节点') }
        /!*cate.children = this.handleTree(response.data, 'id','pid')*!/
        this.cateOptions.push(cate)
        response.data.forEach(e=>{
          this.cateOptions.push(e)
        })
      })
    },*/
    getCateList() {
      /*这个方法是树的写法*/
      merchantIdCategoryTree({"maxLevel":1}).then(response => {
        const cate = { id: "0", categoryName: this.$t('根节点'), children: [] }
        this.cateOptions=response.data
        this.cateOptions.unshift(cate)
      })
    },
    /** 新增按钮操作 */
    handleAdd (parent) {
      this.reset()
      this.getCateList();
      this.form.isFilter=false
      this.form.isHomeVisible=true
      this.form.isVisible=true;
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
      //兼容两种调用：传父分类对象（可带出商城归属）或仅传父分类id
      const parentId = parent && typeof parent === 'object' ? parent.id : parent
      if (parentId) {
        this.form.pid = parentId
        //子分类的商城归属继承父分类，品类编码位数依赖它（配件4位 / 乐器、二手3位）
        if (parent && typeof parent === 'object' && parent.bizScope !== undefined) {
          this.form.bizScope = parent.bizScope
        }
      } else {
        this.form.pid="0"
      }

    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getCateList();

      this.formType = 2
      const id = row ? row.id : ids
      getCategory({"id":id}).then(response => {
        this.form = response.data
        this.originalCategoryCode = response.data.categoryCode
        this.open = true;
        this.formTitle = this.$t('修改')
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },

    limitSort(sort) {
      console.log(sort)
      let val = sort;
      if(val==null||val==undefined||val==''||val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },

    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      }else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },


    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(this.form).then(response => {
              this.$message.success(
                this.$t('修改成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(this.form).then(response => {
              this.$message.success(
                this.$t('新增成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.imgbox {
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  cursor: pointer;

  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.videomask {
  position: absolute;
  z-index: 10;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  line-height: 100px;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .icon {
    display: inline-block;
    font-size: 26px !important;
    color: #fff !important;
  }
}
</style>
